/* eslint-disable prefer-regex-literals */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
import React, { ChangeEventHandler, forwardRef, Ref, useImperativeHandle, useRef, useState } from 'react';
import { Selection, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import { Overlay, OverlayElement, OverlayExtendProps } from 'components/_new/Overlay';
import { Box, BoxSection } from 'components/_new/Box';
import { Button } from 'components/_new/Button';
import { InputText } from 'components/_new/InputText';
import { addMarkData } from '../../utils/SlateUtilityFunctions';
import { CustomEditor, MarkFormat } from '../../types';
import './ColorPicker.css';

export const colors = [
	'#000000',
	'#e60000',
	'#ff9900',
	'#ffff00',
	'#008a00',
	'#0066cc',
	'#9933ff',
	'#ffffff',
	'#facccc',
	'#ffebcc',
	'#ffffcc',
	'#cce8cc',
	'#cce0f5',
	'#ebd6ff',
	'#bbbbbb',
	'#f06666',
	'#ffc266',
	'#ffff66',
	'#66b966',
	'#66a3e0',
	'#c285ff',
	'#888888',
	'#a10000',
	'#b26b00',
	'#b2b200',
	'#006100',
	'#0047b2',
	'#6b24b2',
	'#444444',
	'#5c0000',
	'#663d00',
	'#666600',
	'#003700',
	'#002966',
	'#3d1466',
];

type ColorPickerPopupProps = {
	editor: CustomEditor;
	format: MarkFormat.COLOR | MarkFormat.BACKGROUND_COLOR;
} & Pick<OverlayExtendProps, 'onOpenStateChange'>;

export const ColorPickerPopup = forwardRef(
	({ format, editor, onOpenStateChange }: ColorPickerPopupProps, ref: Ref<OverlayElement>) => {
		const overlayRef = useRef<OverlayElement>(null);
		const [selection, setSelection] = useState<Selection>(null);

		useImperativeHandle(ref, () => ({
			open: (element: HTMLElement) => {
				//
			},
			close: () => {
				//
			},
			isOpen: () => {
				return false;
			},
			toggle: (element: HTMLElement) => {
				if (overlayRef?.current && element) {
					setSelection(editor.selection);
					if (selection) {
						ReactEditor.focus(editor);
					}

					overlayRef.current.toggle(element);
				}
			},
			getElement: () => overlayRef?.current?.getElement() || null,
		}));

		const [hexValue, setHexValue] = useState('');
		const [validHex, setValidHex] = useState(false);

		const isValideHexSix = new RegExp('^#[0-9A-Za-z]{6}');
		const isValideHexThree = new RegExp('^#[0-9A-Za-z]{3}');

		const changeColor = (color: string) => {
			if (selection) {
				Transforms.select(editor, selection);
				ReactEditor.focus(editor);
			}

			addMarkData(editor, format, color);
			overlayRef?.current?.close();
		};

		const handleHexChange: ChangeEventHandler<HTMLInputElement> = (event) => {
			event.preventDefault();
			const newHex = event.currentTarget.value;
			setValidHex(isValideHexSix.test(newHex) || isValideHexThree.test(newHex));
			setHexValue(newHex);
		};

		const handleApply = () => {
			if (!validHex) {
				return;
			}
			if (selection) {
				Transforms.select(editor, selection);
			}
			addMarkData(editor, format, hexValue);
			setValidHex(false);
			setHexValue('');
			if (selection) {
				ReactEditor.focus(editor);
			}
			overlayRef?.current?.close();
		};

		return (
			<Overlay ref={overlayRef} onOpenStateChange={onOpenStateChange}>
				<Box variant="white-bordered" className="editor-popup" slim dropShadow>
					<BoxSection>
						<div className="color-options">
							{colors.map((color) => (
								<div
									key={color}
									onClick={() => changeColor(color)}
									className="option"
									style={{ background: color }}
								/>
							))}
						</div>
						<p style={{ textAlign: 'center', opacity: '0.7', width: '100%' }}>OR</p>
						<div className="hexPreview" style={{ background: validHex ? hexValue : '#000000' }} />

						<InputText type="color" placeholder="#000000" value={hexValue} onChange={handleHexChange} />
						<Button label="Zastosuj" onClick={handleApply} disabled={!isValideHexSix} />
					</BoxSection>
				</Box>
			</Overlay>
		);
	}
);
